import { updateCurrentUserProfile } from '../../../services/users';
import { withSubmitApiCall } from '../../../components/higher-order/withSubmitApiCall';
import ProfileForm from '../../../components/user/forms/ProfileForm';

const EditProfileForm = withSubmitApiCall(updateCurrentUserProfile)(
  ProfileForm,
);

export default EditProfileForm;
